export default __webpack_public_path__ + "static/media/DSC_0512.0c2465ff.jpg";